import StatsCard from "../../../components/stats-card";

export default function LowStockCard({
  styles,
  totalLowDisplay,
  lowBranchesDisplay,
  criticalLowDisplay,
  lowKpiError,
  onOpen,
}) {
  return (
    <StatsCard title="Low Stock Alerts" icon="alert" onClick={onOpen}>
      <p className={styles.alertNumber}>{totalLowDisplay}</p>
      <p className={styles.alertText}>items across {lowBranchesDisplay} branches</p>
      <p className={styles.criticalText}>{criticalLowDisplay} items critical</p>
      {lowKpiError && <p className="text-red-500 text-xs mt-1">{lowKpiError}</p>}
    </StatsCard>
  );
}
